import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import OffersIndex from '@/views/offers/index.vue'
import OfferDetails from '@/views/offers/offer-details.vue'

const offersRoutes: RouteRecordRaw[] = [
  {
    path: '/offers',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'Offers', component: OffersIndex },
      { path: ':id', name: 'Offer-Details', component: OfferDetails, props: true },
    ],
  },
]

export default offersRoutes
